import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import infoList from "../../mixins/infoList";
import { xingxingList } from "@/api/xingxing";
import { syncCpConfig } from "@/api/data";
import XingxingOptions from "../../components/serverList/xingxingOptions.vue";
export default {
  components: {
    XingxingOptions: XingxingOptions
  },
  name: "gameEventConfig",
  mixins: [infoList],
  data: function data() {
    return {
      //分页
      listApi: xingxingList,
      searchInfo: {
        xingxing_id: ""
      }
    };
  },
  created: function created() {
    this.queryEvent();
  },
  methods: {
    queryEvent: function queryEvent() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getTableData();
            case 2:
              if (!_this.tableData || _this.tableData && _this.tableData.length === 0) {
                _this.$message({
                  message: "暂无数据"
                });
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openConfig: function openConfig() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return syncCpConfig({
                type: "c_xingxing"
              });
            case 2:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.$message({
                  message: "同步cp配置成功",
                  type: "success"
                });
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    openPop: function openPop() {
      this.$notify({
        title: "流水原因配置",
        dangerouslyUseHTMLString: true,
        message: "<div>(1)显示研发各项事件原因，包括道具流水原因，货币流水原因，其他流水原因。</div>" + "<div>(2)包含事件Id，事件名称，同时添加事件原因更新功能，点击更新请求研发提供的接口更新事件配置。</div>",
        duration: 0
      });
    }
  }
};